import { eLoaiQuyetDinh } from "../../../model/common/eLoaiQuyetDinh";
import { IQuanLyHocPhanSelectRequest } from "../../../model/request/quyet-dinh/IQuanLyHocPhanSelectRequest";
import { IQuanLyHocPhanhActionTypes } from "../../action-types/quyet-dinh/IQuanLyHocPhanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IQuanLyHocPhanReducer } from "../../reducer-model/quyet-dinh/IQuanLyHocPhanReducer";

const iniState: IQuanLyHocPhanReducer = {
  status: eReducerStatusBase.is_not_initialization,
  quanLyHocPhans: [],
  quanLyDeThis: [],
  idSelections: [],
  request: {} as IQuanLyHocPhanSelectRequest,
};

export const QuanLyHocPhanReducer = (
  state: IQuanLyHocPhanReducer = iniState,
  action: IQuanLyHocPhanhActionTypes
): IQuanLyHocPhanReducer => {
  switch (action.type) {
    case "QUAN_LY_HOC_PHAN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "QUAN_LY_HOC_PHAN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        quanLyHocPhans: [
          ...action.payload.filter(
            (g) => g.quyet_dinh.loai_quyet_dinh === eLoaiQuyetDinh.cau_hoi
          ),
        ],
        quanLyDeThis: [
          ...action.payload.filter(
            (g) => g.quyet_dinh.loai_quyet_dinh === eLoaiQuyetDinh.de_thi
          ),
        ],
      };
    case "QUAN_LY_HOC_PHAN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "QUAN_LY_HOC_PHAN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "QUAN_LY_HOC_PHAN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "QUAN_LY_HOC_PHAN_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "QUAN_LY_HOC_PHAN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "QUAN_LY_HOC_PHAN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "QUAN_LY_HOC_PHAN_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "QUAN_LY_HOC_PHAN_SHOW_EDIT_MODAL":
      return {
        ...state,
        quanLyHocPhanEditings: action.payload,
        isShowEditModal: true,
      };
    case "QUAN_LY_HOC_PHAN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        quanLyHocPhanEditings: undefined,
        isShowEditModal: false,
      };
    case "QUAN_LY_HOC_PHAN_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "QUAN_LY_HOC_PHAN_CHANGE_REQUEST":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
